import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import './AdminDashboard.css';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProperties: 0,
    forSale: 0,
    forRent: 0,
    upcoming: 0,
    ongoing: 0
  });
  const [recentProperties, setRecentProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        // Fetch property statistics
        const statsResponse = await axios.get('https://gladious-constructions.onrender.com/api/properties/stats');
        setStats({
          totalProperties: statsResponse.data.totalProperties || 0,
          forSale: statsResponse.data.forSale || 0,
          forRent: statsResponse.data.forRent || 0,
          upcoming: statsResponse.data.upcoming || 0,
          ongoing: statsResponse.data.ongoing || 0
        });

        // Fetch recent properties
        const recentResponse = await axios.get('https://gladious-constructions.onrender.com/api/properties/recent');
        setRecentProperties(recentResponse.data || []);

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // Format date for display
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Chart data based on property creation dates
  const chartData = [
    { name: 'Jan', Properties: 0 },
    { name: 'Feb', Properties: 0 },
    { name: 'Mar', Properties: 0 },
    { name: 'Apr', Properties: 0 },
    { name: 'May', Properties: 0 },
    { name: 'Jun', Properties: 0 },
    { name: 'Jul', Properties: 0 },
    { name: 'Aug', Properties: 0 },
    { name: 'Sep', Properties: 0 },
    { name: 'Oct', Properties: 0 },
    { name: 'Nov', Properties: 0 },
    { name: 'Dec', Properties: 0 }
  ];

  // Populate chart data with actual property counts per month
  recentProperties.forEach(property => {
    const month = new Date(property.createdAt).getMonth();
    chartData[month].Properties += 1;
  });

  return (
    <>
      <Helmet>
                <title>Admin Dashboard</title>
                <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
              </Helmet>
              
    <div className="dashboard-container">      
      <main className="dashboard-main">
        <section className="dashboard-cards">
          <div className="card">
            <h3>Total Properties</h3>
            <p>{loading ? '...' : stats.totalProperties}</p>
          </div>
          <div className="card">
            <h3>For Sale</h3>
            <p>{loading ? '...' : stats.forSale}</p>
          </div>
          <div className="card">
            <h3>For Rent</h3>
            <p>{loading ? '...' : stats.forRent}</p>
          </div>
          <div className="card">
            <h3>Ongoing</h3>
            <p>{loading ? '...' : stats.ongoing}</p>
          </div>
          <div className="card">
            <h3>Upcoming</h3>
            <p>{loading ? '...' : stats.upcoming}</p>
          </div>
        </section>
        
        <section className="dashboard-chart">
          <h2>Monthly Properties Added</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
<Bar dataKey="Properties" fill="#ddaf00" radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </section>
        
        <section className="dashboard-table">
          <h2>Recent Properties</h2>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Location</th>
                <th>Added On</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4">Loading recent properties...</td>
                </tr>
              ) : recentProperties.length > 0 ? (
                recentProperties.map(property => (
                  <tr key={property._id}>
                    <td>{property.title}</td>
                    <td>
                      <span className={`project-type ${property.projectType}`}>
                        {property.projectType.replace('-', ' ')}
                      </span>
                    </td>
                    <td>{property.location?.city}, {property.location?.country}</td>
                    <td>{formatDate(property.createdAt)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No properties found</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </main>
    </div>
  </>
  );
};

export default AdminDashboard;